import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';
import { CLOUD_KEYS_KEY } from './RunPodKeyPanel';

/** A storage key is reachable — kept on Couch or held by a home machine (docs 73–76). */
export function useStorageConnected(): boolean {
  const keys = useQuery({ queryKey: CLOUD_KEYS_KEY, queryFn: api.cloudKeys });
  const s3 = keys.data?.s3;
  return Boolean(s3 && (s3.server.set || s3.machines.length > 0));
}
